import documentReady from './documentReady.ts'

type EventParameters = {
  event_action: string
  event_category: string
  event_label: string
  event_value?: string
}

type Gtag = {
  (type: string, eventName: string, eventParameters: EventParameters): void
}

declare let gtag: Gtag

function googleEventTracking (): void {
  function trackGoogleEvent (event): void {
    // No Analytics in dev.
    if (typeof gtag === 'undefined') {
      return
    }

    const { target } = event

    const eventName = target.dataset.eventAction
    const eventParameters: EventParameters = {
      event_action: eventName,
      event_category: target.dataset.eventCategory,
      event_label: target.dataset.eventLabel
    }
    const { eventValue } = target.dataset
    if (eventValue) {
      eventParameters.event_value = eventValue
    }
    gtag('event', eventName, eventParameters)
  }

  document.querySelectorAll('.click-track').forEach((el) => el.addEventListener('click', (ev) => trackGoogleEvent(ev)))
}

documentReady(googleEventTracking)
